module.exports = __webpack_public_path__ + "static/media/kingOfCapot-1.6fb9652b.png";